export default __webpack_public_path__ + "static/media/Lilith_White.400df33c.png";